import { Box } from '@bpba/ui-components';
import { FC } from 'react';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { NumberFormat } from '../../config/NumberFormat';
import { LoginData } from '../../model/LoginData';

const NAME_SEPARATOR_PATTERN = /[\s,]+/;

type Props = {
  color?: string;
};

export const UserPannel: FC<Props> = ({ color }) => {
  const { isLoggedin, loginData } = useUserStatus();

  return (
    <Box
      flexDirection={['row', null, null, 'column']}
      marginRight={['0px', null, null, '8px']}
      marginTop={['16px', null, null, '0px']}
      alignItems={['end']}
      width="100%"
      lineHeight="20px !important"
      color={color}
      display={isLoggedin ? 'flex' : 'none'}
      tabIndex={0}
    >
      {capitalizeFirstChar(loginData?.user?.name)}
      <PointsMessage loginData={loginData} />
    </Box>
  );
};

const capitalizeFirstChar = (str?: string) => {
  return str
    ? str
        .toLowerCase()
        .split(NAME_SEPARATOR_PATTERN)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
        .trim()
    : '';
};

type PointsMessageProps = {
  loginData?: LoginData | null;
};

const PointsMessage: FC<PointsMessageProps> = ({ loginData }) => {
  const pointsFormatted = () => {
    return NumberFormat.formatNumber(loginData?.user?.points);
  };

  if (loginData?.user?.points == null) return <></>;

  return (
    <div>
      &nbsp;tenés&nbsp;
      <b>{pointsFormatted()}</b>
      &nbsp;
      {loginData?.user?.points === 1 ? 'punto' : 'puntos'}
    </div>
  );
};
